const toPercentage = (value: number): string => {
  return `${Math.round(value * 100)}%`;
};

export { toPercentage };
